import createActions from 'utils/redux/createActions'

export default createActions([
    'SORT_CHANGE'
  , 'CHOOSE_ITEM'
])



// WEBPACK FOOTER //
// ./src/actions/table.js